import React, { useRef, useEffect, useState } from 'react';
import {
  HeroContainer,
  WavyBackground,
  ContentContainer,
  Title,
  Subtitle,
  PhoneButtonContainer,
  CallingMessage,
  CallingText,
  AcronymSection,
  AcronymList,
  AcronymItem,
  AcronymLetter,
  AcronymText,
  DescriptionSection,
  DescriptionText,
  EnergyParticles,
  EnergyParticle,
  EnergyCircle,
  HighlightedWord
} from './ThankYouStyles';
import ChannelsComponentUS from './ChannelsSectionUS';
import ProcessFlowSectionUS from './ProcessFlowSectionUS';
import PlatformVideoSectionUS from './PlatformVideoSectionUS';
import ActionButtons from './ActionButtons';
import ScheduleButtonSectionUS from './ScheduleButtonSectionUS';

const ThankYouSectionUS = () => {
  const [isAcronymVisible, setIsAcronymVisible] = useState(false);
  const acronymRef = useRef(null);

  // BIANCA acronym data in English
  const acronymData = [
    { letter: 'B', text: 'Artificial Intelligence' },
    { letter: 'I', text: 'bot for' },
    { letter: 'A', text: 'scheduling' },
    { letter: 'N', text: 'and' },
    { letter: 'C', text: 'lead' },
    { letter: 'A', text: 'nurturing' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsAcronymVisible(true);
        }
      },
      { 
        threshold: 0.6,
        rootMargin: "-10px"
      }
    );

    if (acronymRef.current) {
      observer.observe(acronymRef.current);
    }

    return () => {
      if (acronymRef.current) {
        observer.unobserve(acronymRef.current);
      }
    };
  }, []);

  // Generate random energy particles
  const renderEnergyParticles = () => {
    const particles = [];
    const colors = ['#00FFFF', '#64B6FF', '#0080FF', '#FFFFFF'];
    const sizes = ['4px', '6px', '8px', '10px'];
    
    for (let i = 0; i < 20; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const duration = `${2 + Math.random() * 3}s`;
      const delay = `${Math.random() * 2}s`;
      
      particles.push(
        <EnergyParticle 
          key={i}
          top={top}
          left={left}
          color={color}
          size={size}
          duration={duration}
          delay={delay}
        />
      );
    }
    
    return particles;
  };

  return (
    <HeroContainer>
      <WavyBackground />
      <ContentContainer>
        <Title>
          <div className="logo-container">
            <div className="logo-tech-circle"></div>
            <div className="logo-tech-data"></div>
            <img src="/favicon.png" alt="Logo Bianca" className="title-logo" />
          </div>
          <div className="title-text-container">
            <div className="tech-data-top">// AI.AGENT</div>
            <span className="title-text">BIANCA</span>
            <div className="tech-data-bottom">{/* data.transform(leads) */}</div>
          </div>
        </Title>
        <Subtitle>
          Transforming leads into appointments
        </Subtitle>
        
        <PhoneButtonContainer>
          <CallingMessage>
            <CallingText>Thank you, Bianca is calling you</CallingText>
          </CallingMessage>
        </PhoneButtonContainer>
        
        {/* BIANCA acronym explanation section */}
        <AcronymSection ref={acronymRef} isVisible={isAcronymVisible}>
          <AcronymList>
            {acronymData.map((item, index) => (
              <AcronymItem key={index} index={index} isVisible={isAcronymVisible}>
                <AcronymLetter isVisible={isAcronymVisible}>{item.letter}</AcronymLetter>
                <AcronymText index={index} isVisible={isAcronymVisible}>{item.text}</AcronymText>
              </AcronymItem>
            ))}
          </AcronymList>
        </AcronymSection>
        
        {/* Schedule button after acronym section */}
        <ScheduleButtonSectionUS />
        
        {/* BIANCA description section */}
        <DescriptionSection>
          <EnergyParticles>
            {renderEnergyParticles()}
          </EnergyParticles>
          <EnergyCircle />
          <DescriptionText>
            BIANCA is an AI agent specialized in <HighlightedWord>maximizing</HighlightedWord> the conversion of <HighlightedWord>leads</HighlightedWord> into <HighlightedWord>appointments</HighlightedWord>
          </DescriptionText>
        </DescriptionSection>
        
        {/* Channels section */}
        <ChannelsComponentUS />
        
        {/* Process flow section */}
        <ProcessFlowSectionUS />
        
        {/* Platform video section */}
        <PlatformVideoSectionUS />
        
        {/* Action buttons */}
        <ActionButtons />
      </ContentContainer>
    </HeroContainer>
  );
};

export default ThankYouSectionUS;
